const toggleState = (element, off, on)  => {
  const elem = document.querySelector(element);
  elem.setAttribute('data-state', elem.getAttribute('data-state') === off ? on : off);
}

export default toggleState;